<template>
  <div class="later-step">
    <div class="later-content">
      <!-- Content Section -->
      <div class="content-section">
        <!-- Image -->
        <div class="image-container">
          <img
            :src="imageUrl"
            alt="Отличное начало"
            class="later-image"
          />
        </div>

        <!-- Text Block -->
        <div class="text-block">
          <h2 class="step-title">{{ step.title }}</h2>
          <p v-if="step.subtitle" class="step-subtitle">{{ formattedSubtitle }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useTasteClarificationModal } from '@/features/taste/store'
import type { TasteStep } from '@/features/taste/types/taste-config'

interface Props {
  step: TasteStep & { type: 'later' }
}

const props = defineProps<Props>()
const tasteStore = useTasteClarificationModal()
const router = useRouter()

const imageUrl = '/img/avatar-taste.png' // Placeholder, нужно будет заменить на реальное изображение

const formattedSubtitle = computed(() => {
  if (!props.step.subtitle) return ''
  // Заменяем \n на <br> для переносов строк
  return props.step.subtitle.split('\n').join('<br>')
})
</script>

<style scoped>
.later-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  width: 100%;
}

.later-content {
  max-width: 1020px;
  width: 100%;
}

.content-section {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 40px;
  padding: 40px 120px;
}

.image-container {
  flex-shrink: 0;
}

.later-image {
  width: 234px;
  height: 234px;
  border-radius: 20px;
  object-fit: cover;
}

.text-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}

.step-title {
  font-family: Gilroy, sans-serif;
  font-size: 48px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.04em;
  color: #232F45;
  margin: 0;
  text-align: left;
}

.step-subtitle {
  font-family: Inter, sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 1.3;
  letter-spacing: -0.04em;
  color: rgba(35, 47, 69, 0.8);
  margin: 0;
  text-align: left;
  white-space: pre-line;
}

@media (min-width: 1440px) and (max-width: 1919px) {
  .content-section {
    padding: 40px 80px;
  }

  .step-title {
    font-size: 42px;
  }

  .step-subtitle {
    font-size: 18px;
  }
}

@media (min-width: 1024px) and (max-width: 1439px) {
  .content-section {
    padding: 40px 60px;
    gap: 32px;
  }

  .later-image {
    width: 200px;
    height: 200px;
  }

  .step-title {
    font-size: 36px;
  }

  .step-subtitle {
    font-size: 18px;
  }
}

@media (min-width: 768px) and (max-width: 1023px) {
  .later-step {
    padding: 0;
  }

  .content-section {
    padding: 40px 40px;
    gap: 24px;
  }

  .later-image {
    width: 180px;
    height: 180px;
  }

  .step-title {
    font-size: 32px;
  }

  .step-subtitle {
    font-size: 16px;
  }
}

@media (min-width: 393px) and (max-width: 767px) {
  .later-step {
    padding: 0;
  }

  .later-content {
    padding: 0 20px 20px;
  }

  .content-section {
    flex-direction: column;
    padding: 0;
    gap: 20px;
    align-items: stretch;
  }

  .image-container {
    width: 100%;
  }

  .later-image {
    width: 100%;
    height: 353px;
    align-self: stretch;
  }

  .text-block {
    align-items: flex-start;
  }

  .step-title {
    font-size: 32px;
    line-height: 1.09;
    text-align: left;
  }

  .step-subtitle {
    font-size: 15px;
    line-height: 1.3;
    text-align: left;
  }
}

@media (max-width: 392px) {
  .later-step {
    padding: 0;
  }

  .content-section {
    flex-direction: column;
    padding: 16px;
    gap: 16px;
  }

  .later-image {
    width: 200px;
    height: 200px;
    align-self: center;
  }

  .step-title {
    font-size: 28px;
  }

  .step-subtitle {
    font-size: 14px;
  }
}
</style>

